import { createBrowserHistory } from 'history';
import 'url-search-params-polyfill';

/* Having to reinstantiate the history object everytime when any of below functions are called, because 
the history.location object wasn't being set to correct url after the user is logged in 
and the call back is completed */
export let history = createBrowserHistory();

export const BrowserHistoryHelper = {
	getCurrentLocation() {
		history = createBrowserHistory();
		return history.location;
	},

	getQueryStringValueFromCurrentLocation(searchString: string) {
		history = createBrowserHistory();
		const urlSearchParams = new URLSearchParams(history.location.search);
		return urlSearchParams.get(searchString);
	},

	setQueryStringForCurrentLocation(queryString: string) {
		history = createBrowserHistory();
		history.replace({
			...location,
			search: queryString,
		});
	},
};
